//import styles from './EventListItem.scss'
import MoreButton from '../../../_atomics/morebutton/morebutton.js'
import PreloadImage from 'react-preload-image'
import date from 'locutus/php/datetime/date'
import in_array from 'locutus/php/array/in_array';
import strftime from 'locutus/php/datetime/strftime';

export default class EventListItem extends React.Component {

  constructor (props) {
    super(props)
  }

  componentDidMount () {
    this.truncateTeaser()
  }

  componentDidUpdate() {
    this.truncateTeaser()
  }

  truncateTeaser() {
    let truncateElement = this.refs.teaser
    let truncateTextParts= truncateElement.innerHTML.split(' ');
    let lineHeight = parseInt(window.getComputedStyle(truncateElement)['line-height']);
    let height = truncateElement.offsetHeight
    let lines = 3

    let c = 0
    while (((lines * lineHeight) <= height) && (c < 40)) {
      height = truncateElement.offsetHeight
      truncateTextParts.pop();
      this.refs.teaser.innerHTML = truncateTextParts.join(' ') + '...';
      c++
    }
  }

  bookingStatus() {
    //set bookout to false ... always, if event is gone
    if (this.props.event.end_ts < this.props.controller.todaybase) {
      this.props.event.booked_out = false;
    }
    const properties = [];

    if (this.props.event.booked_out === true) {
      properties.push('Ausgebucht');
    }

    if (this.props.event.closed === true) {
      properties.push('Geschlossene Veranstaltung');
    }

    return properties.join(', ');
  }

  title() {
    return (
      <h2 class="o-eventlistitem__title">
        <a href={ this.props.event.url } title={ this.props.event.title }>
          { this.bookingStatus() !== '' ? (<span class="o-eventlistitem__booked_out">{this.bookingStatus()}:</span>) : '' }
          <span dangerouslySetInnerHTML={{ __html: this.props.event.title }}></span>
        </a>
      </h2>
    );
  }

  render () {
    let image = null
    const { event } = this.props;

    if (event.image) {
      image = event.image
    }

    let start = new Date(event.dateobj)
    let tz = start.getTimezoneOffset() * 60

    let day = date('d', event.ts + tz)
    let month = strftime('%b', event.ts + tz)
    let time = event.time_start

    let day_end = date('d', event.end_ts + tz)
    let month_end = strftime('%b', event.end_ts + tz)
    let time_end = event.time_end

    let day_string = day + '. ' + month
    if (day+month !== day_end+month_end) {
      if (month === month_end) {
        day_string = day + '.'
      }
      else {
        day_string = day + '. '+month
      }

      day_string += ' - ' + day_end + '. ' + month_end
    }

    let time_line = ''
    if (time !== '') {
      time_line = time
    }
    if (time_end !== '') {
      time_line += ' - ' + time_end
    }
    if (time_line !== '') {
      time_line += ' Uhr'
    }

    let backgroundImage = 'url('+image+')'

    //{<PreloadImage className="o-eventlistitem__cover" src={image} lazy />}

    return (
      <div class="o-eventlistitem">
        {image ? (<a href={event.url} aria-label={event.title}><div class="o-eventlistitem__cover" style={{backgroundImage: backgroundImage}}> </div></a>) : ''}
        <div class="o-eventlistitem__content">
          <EventListItemCategoryLine events_type={event.events_type} events_series={event.events_series} events_topic={event.events_topic} />
          { this.title() }
          <strong class="o-eventlistitem__subtitle">{event.subtitle}</strong>
          <div class="o-eventlistitem__teaser" ref="teaser">{event.teaser}</div>
          <div class="o-eventlistitem__dateline">
            <div class="o-eventlistitem__date">{day_string}</div>
            {time_line !== '' ? (<div class="o-eventlistitem__time">{time_line}</div>) : ''}
          </div>
        </div>
      </div>
    )
  }
}

export class EventListItemCategoryLine extends React.Component {
  render () {

    if ((!this.props.events_topic) && (!this.props.events_type) && (!this.props.events_series)) {
      return null
    }

    const events_topic = []
    this.props.events_topic.map(term => {
      events_topic.push(term)
    })

    const events_type = []
    this.props.events_type.map(term => {
      events_type.push(term)
    })

    const events_series = []
    this.props.events_series.map(term => {
      events_series.push(term)
    })

    return (
      <div class="o-eventlistitem__categories">
        {(events_topic.length > 0) ? (<div class="o-eventlistitem__category">{events_topic.map((term, index) => (<EventListItemCategoryLineItem term={term} islast={index === events_topic.length-1} />))} </div>) : ''}
        {(events_type.length > 0) ? (<div class="o-eventlistitem__category">{events_type.map((term, index) => (<EventListItemCategoryLineItem term={term} islast={index === events_type.length-1} />))} </div>) : ''}
        {(events_series.length > 0) ? (<div class="o-eventlistitem__category">{events_series.map((term, index) => (<EventListItemCategoryLineItem term={term} islast={index === events_series.length-1} />))} </div>) : ''}
      </div>
    )
  }
}

export class EventListItemCategoryLineItem extends React.Component {
  render () {
    if (this.props.term.url) {
      return (
          <span>
            <a href={this.props.term.url}>{this.props.term.name}</a>
            {(this.props.islast === false) ? (', ') : ''}
          </span>
      )
    }
    else {
      return (<span>{this.props.term.name}
        {(this.props.islast === false) ? (', ') : ''}</span>)
    }
  }
}
